import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'bw-overlay',
  styles: [
    `
      .overlay{
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          min-height: 100%;
          /*  z-index: 10;
          background-color: rgba(0,0,0,0.2); dim the background*/
        }
      `
  ],
  template: `<div class="overlay animated fadeIn" [style.background-color]="backgroundColor"></div>`,
})
export class OverlayComponent implements OnInit {

  @Input() opacity: number = 0.2;

  constructor() { }

  get backgroundColor() {
    return 'rgba(0,0,0,' + this.opacity + ')';
  }

  ngOnInit() { }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/ui/overlay/overlay.component.ts